module.exports = __webpack_public_path__ + "static/media/A1-35-Luzzen-cod143-B.89975aa6.png";